import { Color } from "marketpro-design-lib";

export class SpendingDistribution {
  public spending_daily: string;
  public people: number;
  public spending_ppp: number;
  public spending_share: number;
  public id: number;
  public name?: string;
  public color?: Color;
}
